import React, { useState } from "react";

// Production launch gate. Preview/dev hosts stay open; every other host
// (the deployed production domain) shows a full-screen "launching soon" wall.
// Owner backdoor: tap the logo 7 times to reveal an access-code input.
const UNLOCK_KEY = "bliencer_launch_unlock";
const CODE_SHA256 = "77613d5ea9b7ecc6989dc04ba4dc487ba13ff406e69b1407697efd3886bc2ecb";

const isOpenHost = () => {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h.includes("preview.emergentagent.com");
};

async function sha256Hex(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

const LaunchScreen = () => {
  const [taps, setTaps] = useState(0);
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if ((await sha256Hex(code)) === CODE_SHA256) {
      localStorage.setItem(UNLOCK_KEY, "1");
      window.location.reload();
    } else {
      setError(true);
      setCode("");
    }
  };

  return (
    <div
      data-testid="launch-lock-screen"
      className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 text-center select-none"
    >
      <img
        src="/brand/bliencer-wordmark.png"
        alt="Bliencer"
        data-testid="launch-lock-logo"
        onClick={() => setTaps((t) => t + 1)}
        className="h-8 sm:h-9 mb-10 opacity-95 cursor-default"
        draggable={false}
      />
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight">
        We&rsquo;re launching soon.
      </h1>
      <p className="mt-5 max-w-md text-base text-[#a0a0a0] leading-relaxed">
        Bliencer is putting the finishing touches on something worth the wait.
      </p>
      <div className="mt-10 h-px w-16 bg-[#2b2b2b]" />

      {taps >= 7 && (
        <form onSubmit={submit} className="mt-10 flex items-center gap-3" data-testid="launch-lock-form">
          <input
            type="password"
            value={code}
            autoFocus
            onChange={(e) => { setCode(e.target.value); setError(false); }}
            placeholder="Access code"
            data-testid="launch-lock-code-input"
            className={`w-56 bg-[#111] border rounded-full px-5 py-2.5 text-sm outline-none transition-colors ${
              error ? "border-red-500/70" : "border-[#2b2b2b] focus:border-[#6589ff]/60"
            }`}
          />
          <button
            type="submit"
            data-testid="launch-lock-submit-button"
            className="rounded-full border border-[#2b2b2b] bg-white text-black px-5 py-2.5 text-sm font-semibold btn-anim"
          >
            Enter
          </button>
        </form>
      )}
    </div>
  );
};

export const LaunchLock = ({ children }) => {
  if (isOpenHost() || localStorage.getItem(UNLOCK_KEY) === "1") return children;
  return <LaunchScreen />;
};

export default LaunchLock;
